import { SVGProps } from 'react'

function Spinner(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.667 8H16a8 8 0 1 1-8-8v1.333A6.667 6.667 0 1 0 14.667 8Z"
        fill="currentColor"
      />
    </svg>
  )
}

Spinner.defaultProps = { role: 'graphics-document' }

export default Spinner
